import React, { useState, useEffect } from "react";
import { object, array, bool, string, func } from "prop-types";
import { Link } from "@quintype/components";
import { connect } from "react-redux";
import get from "lodash/get";
import assetify from "@quintype/framework/assetify";

import StoryCard from "../../story-templates/StoryCard";
import RelatedStories from "../RelatedStories";
import RelatedStoriesWithImageRight from "../RelatedStoriesWithImageRight";
import StoryTag from "../../story-templates/StoryTag";
import ScrollSnap from "../../atoms/ScrollSnap";
import LeftArrowButton from "../../atoms/icons/left-arrow-button";
import RightArrowButton from "../../atoms/icons/right-arrow-button";
import Icon from "../../icons";
import { toBanglaNum, googleTagEvents } from "../../utils/utils";
import StoryPageMetaData from "../StoryPageMetaData";
import DfpAd from "../../dfp-ad";
import StoryPageMetaDataIcons from "../StoryPageMetaDataIcons";
import { setMetypeBar } from "../../helper/actions";
import { staticTexts } from "../../utils/Translate";
import LightBox from "../LightBox";
import Plus from "../../atoms/icons/Plus";
import FullScreenIcon from "../../../../assets/icons/full-screen-icon.png";
import StoryHeroImage from "../../atoms/StoryHeroImage";

import "./storyContent.m.css";

const StoryContent = ({
  story = null,
  slicedStoryCards = [],
  isLiveBlog = false,
  checkKeyElements = false,
  imageElements = null,
  isPhotoStory = false,
  showMetadata = true,
  domainSlug,
  publisherAttributes,
  isMobile,
  bottomAd,
  bottomAdPresence,
  storyFromReducer,
  datatrackingcategory = "",
  datatrackingaction = "",
}) => {
  const [showCarousel, setShowCarousel] = useState(false);
  const [carouselIndex, setCarouselIndex] = useState(null);
  const [selectedIndex, setSelectedIndex] = useState(0);
  const [relStories, setRelStories] = useState([]);
  const [socialShareButtonStyle, setSocialShareButtonStyle] = useState(false);
  const [lowerBottomAd, setLowerBottomAd] = useState(false);
  const socialShareStyle = bottomAd && bottomAdPresence ? "social-share-slide-up" : "";

  const selectionChange = (index) => setSelectedIndex(index);
  const sectionName = get(story, ["sections", "0"], "");

  useEffect(() => {
    if (story["story-template"] === "live-blog") {
      global.deviceWidth < 1264 && setLowerBottomAd(!lowerBottomAd);
    }

    if (story.tags.length > 0) {
      fetch(
        `/api/v1/advanced-search?tag-name=${decodeURIComponent(story.tags[0].name)}&not-story-content-ids=${
          story.id
        }&limit=8&sort=latest-published`
      )
        .then(function (res) {
          res.json().then(function (data) {
            setRelStories(data.items);
          });
        })
        .catch(function (err) {
          console.log("Fetch Error :-S", err);
        });
    } else {
      setRelStories([]);
    }
  }, [storyFromReducer]);

  const children =
    imageElements && imageElements.length > 0
      ? imageElements.map((item, index) => <LightBox element={item} isCarousel={true} key={index} />)
      : null;

  const getCarouselIndex = (element) => {
    return imageElements.findIndex((item) => item.id === element.id);
  };

  const closeEvent = (e) => {
    setShowCarousel(!showCarousel);

    exitFullscreenWindow();
  };

  const carouselEvent = (e, element) => {
    setShowCarousel(!showCarousel);
    setCarouselIndex(getCarouselIndex(element));
  };

  const socialShareButtonClick = () => {
    googleTagEvents("social-share", "Plus Button in Mobile", "");
    setSocialShareButtonStyle(!socialShareButtonStyle);
  };

  useEffect(() => {
    socialShareButtonStyle
      ? (global.document.body.style.cssText = "overflow: hidden")
      : (global.document.body.style.cssText = "overflow-x: hidden, overflow-y: auto");
  }, [socialShareButtonStyle]);

  const adTitle = staticTexts(publisherAttributes.lang).advertising;

  const exitFullscreenWindow = () => {
    if (document.fullscreenElement) {
      document
        .exitFullscreen()
        .then(() => console.log("exited form Full Screen mode"))
        .catch((err) => console.error(err));
    }
  };

  const makeFullScreen = () =>
    document.fullscreenElement ? exitFullscreenWindow() : document.documentElement.requestFullscreen();

  return (
    <React.Fragment>
      <div className={`story-content ${!checkKeyElements ? "no-key-elements" : ""}`}>
        <div>
          {story["story-template"] !=="photo" && story["hero-image-s3-key"] && <StoryHeroImage story={story} imageWidth={isMobile ? [375] : [1140]} />}
          {showCarousel && (
            <div styleName="scroll-snap">
              <ScrollSnap
                leftArrow={<LeftArrowButton />}
                rightArrow={<RightArrowButton />}
                defaultSelection={carouselIndex}
                selectionChange={selectionChange}
              >
                {children}
              </ScrollSnap>
              <div styleName="icons">
                <span styleName="image-index">{`${
                  publisherAttributes.lang === "en" ? selectedIndex + 1 : toBanglaNum(selectedIndex + 1)
                }/${
                  publisherAttributes.lang === "en" ? imageElements.length : toBanglaNum(imageElements.length)
                }`}</span>
                <img src={`${assetify(FullScreenIcon)}`} styleName="full-screen-icon" onClick={makeFullScreen}></img>
                <span onClick={() => closeEvent()}>
                  <Icon type="close" className="close" />
                </span>
              </div>
            </div>
          )}
          <div>
            {showMetadata && <StoryPageMetaData story={story} lang={publisherAttributes.lang} />}
            {slicedStoryCards.length > 0 &&
              slicedStoryCards.map((card, index) => (
                <div key={card.id} id={card.id}>
                  {!isLiveBlog && (
                    <StoryCard
                      card={card}
                      story={story}
                      onCarouselEvent={carouselEvent}
                      publisherAttributes={publisherAttributes}
                      domainSlug={domainSlug}
                    />
                  )}
                  {isLiveBlog && (
                    <div styleName="live-blog-card-wrapper" className="live-blog-card">
                      <div styleName={`time-wrapper ${publisherAttributes.lang === "en" ? "en-time-wrapper" : ""}`}>
                        {new Date(card["card-added-at"]).toLocaleTimeString(
                          publisherAttributes.lang === "en" ? "en" : "bn-BN"
                        )}
                      </div>
                      <StoryCard
                        card={card}
                        story={story}
                        id={`#card-${card.id}`}
                        isLiveBlog={isLiveBlog}
                        publisherAttributes={publisherAttributes}
                        domainSlug={domainSlug}
                      />
                    </div>
                  )}
                  {slicedStoryCards.length > 0 && index === 0 && (
                    <div
                      styleName={`adslot adslot-300x250 ${isLiveBlog ? "live-blog-ad" : ""}`}
                      className="print-adslot"
                    >
                      <div styleName="advertising">{adTitle}</div>
                      <DfpAd
                        adtype={
                          publisherAttributes.lang === "en" ? "EnPalo_InArticle_300x250" : "News_InArticle_300x250"
                        }
                        targetStory={story}
                        slotId={`${
                          publisherAttributes.lang === "en" ? "EnPalo_InArticle_300x250" : "News_InArticle_300x250"
                        }-${story.id.slice(-5)}-${card.id.slice(-5)}`}
                      />
                    </div>
                  )}
                  {slicedStoryCards.length > 1 && index === 1 && (
                    <div styleName={`adslot`} className="print-adslot">
                      <DfpAd
                        adtype={"mcanvas1x1"}
                        targetStory={story}
                        slotId={`mcanvas-ad-${story.id.slice(-5)}-${card.id.slice(-5)}`}
                      />
                    </div>
                  )}
                  {slicedStoryCards.length > 2 && index === 2 && (
                    <div
                      styleName={`adslot adslot-300x250 ${isLiveBlog ? "live-blog-ad" : ""}`}
                      className="print-adslot"
                    >
                      <div styleName="advertising">{adTitle}</div>
                      <DfpAd
                        adtype={
                          publisherAttributes.lang === "en" ? "EnPalo_InArticle2_300x250" : "News_InArticle2_300x250"
                        }
                        targetStory={story}
                        slotId={`${
                          publisherAttributes.lang === "en" ? "EnPalo_InArticle2_300x250" : "News_InArticle2_300x250"
                        }-${story.id.slice(-5)}-${card.id.slice(-5)}`}
                      />
                    </div>
                  )}
                  {slicedStoryCards.length > 3 && index === 3 && (
                    <div styleName={`adslot`} className="print-adslot">
                      <DfpAd
                        adtype={"News_InArticle_RichMdia"}
                        targetStory={story}
                        slotId={`News_InArticle_RichMdia-${story.id.slice(-5)}-${card.id.slice(-5)}`}
                      />
                    </div>
                  )}
                  {slicedStoryCards.length > 5 && index === 5 && (
                    <div styleName="adslot live-blog-ad" className="print-adslot">
                      <div styleName="advertising">{adTitle}</div>
                      <DfpAd
                        adtype={publisherAttributes.lang === "en" ? "EnPalo_ROS_728x90_B2" : "News_728x90_B2"}
                        targetStory={story}
                        slotId={`${
                          publisherAttributes.lang === "en" ? "EnPalo_ROS_728x90_B2" : "News_728x90_B2"
                        }-${story.id.slice(-5)}-${card.id.slice(-5)}`}
                      />
                    </div>
                  )}
                </div>
              ))}
          </div>
          <div styleName="tags-with-social-share-wrapper">
            {story.tags && story.tags.length > 0 && (
              <div styleName="tags wrapper" className="print-tags">
                {sectionName && (
                  <Link
                    href={sectionName["section-url"]}
                    styleName="sub-section-name"
                    data-tracking-category={datatrackingcategory}
                    data-tracking-action={datatrackingaction}
                    data-tracking-label={sectionName["display-name"]}
                  >
                    {publisherAttributes.lang === "en"
                      ? story["story-template"] === "photo"
                        ? "Watch more from "
                        : "Read more from "
                      : ""}
                    <span styleName="section-name">{sectionName["display-name"]}</span>
                    {publisherAttributes.lang === "bn"
                      ? story["story-template"] === "photo"
                        ? " থেকে আরও দেখুন"
                        : " থেকে আরও পড়ুন"
                      : ""}
                  </Link>
                )}
                <StoryTag tags={story.tags} />
              </div>
            )}
          </div>

          {((story["story-template"] === "text" && isMobile) || lowerBottomAd) && (
            <div styleName="adslot" className="print-adslot">
              <div styleName="advertising">{adTitle}</div>
              <DfpAd
                adtype={publisherAttributes.lang === "en" ? "EnPalo_ROS_336x280_R1" : "News_336x280_R1"}
                targetStory={story}
                slotId={`${
                  publisherAttributes.lang === "en" ? "EnPalo_ROS_336x280_R1" : "News_336x280_R1"
                }-${story.id.slice(-5)}-bottom-ad`}
              />
            </div>
          )}
          <div
            className="print-social-share-button"
            styleName={`social-share-button ${socialShareButtonStyle ? "change-bg" : ""}`}
          >
            <div
              styleName={`share-button-container ${socialShareButtonStyle ? "more-buttons" : ""} ${socialShareStyle}`}
            >
              {socialShareButtonStyle && <StoryPageMetaDataIcons color1="#000" color2="#222" clickFrom="mobile-plus" />}
              <div onClick={socialShareButtonClick}>
                <Plus />
              </div>
            </div>
          </div>
        </div>
        <div className="print-related-stories-wrapper">
          {!isMobile && relStories.length > 0 && (
            <div styleName="sticky-content"><RelatedStoriesWithImageRight stories={relStories.slice(4, 8)} /></div>
          )}
        </div>
      </div>
      <div>
        {relStories.length > 0 && (
          <div styleName="related-stories-wrapper wrapper" className="print-related-stories-wrapper">
            <RelatedStories stories={relStories.slice(0, 4)} />
          </div>
        )}
      </div>
    </React.Fragment>
  );
};

StoryContent.propTypes = {
  story: object.isRequired,
  slicedStoryCards: array,
  isLiveBlog: bool,
  checkKeyElements: bool,
  imageElements: array,
  isPhotoStory: bool,
  showMetadata: bool,
  domainSlug: string,
  publisherAttributes: object,
  isMobile: bool,
  bottomAd: bool,
  bottomAdPresence: bool,
  storyFromReducer: string,
  storyIndex: string,
  datatrackingcategory: string,
  datatrackingaction: string,
};

const mapStateToProps = (state) => ({
  member: state.member,
  domainSlug: get(state, ["qt", "domainSlug"]),
  metypeConfig: get(state, ["qt", "config", "publisher-attributes", "metypeConfig"], {}),
  isMetypeBar: get(state, ["metypeReducer", "isMetypeBar"], false),
  publisherAttributes: get(state, ["qt", "config", "publisher-attributes"], {}),
  authHost: get(state, ["qt", "config", "publisher-attributes", "auth_host"], null),
  bottomAdPresence: get(state, ["breakingNewsAdReducer", "adPresence"], false),
  bottomAd: get(state, ["TopAndBottomAdReducer", "showAd"], false),
  storyFromReducer: get(state, ["headerReducer", "showStoryHeader"], ""),
  storyIndex: get(state, ["headerReducer", "showStoryHeader", "storyIndex"], "0"),
});

const mapDispatchToProps = (dispatch) => ({
  setMetypeBar: (flag) => dispatch(setMetypeBar(flag)),
});

export default connect(mapStateToProps, mapDispatchToProps)(StoryContent);
